import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

import {inventory_service_login} from "../slices/auth";

const InventoryServiceLogin = () => {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();
  const hasFetched = React.useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");
    
    if (token) {
      hasFetched.current = true;
      setLoading(true);
      dispatch(inventory_service_login({ token }))
        .unwrap()
        .then((response) => {
          let page = urlSearchParams.get("redirect") || "/inventory";
          if (page === "/inventory" && response.user && response.user.clientId) {
              page += "?client=" + response.user.clientId;
          }
          navigate(page);
          window.location.reload();
        })
        .catch((error) => {
          setLoading(false);
          setMessage("Failed to login automatically. Token might be invalid or expired.");
        });
    } else {
        setMessage("Invalid request. Missing token.");
    }
  }, [dispatch, navigate]);

  return (
    <div className="col-md-12 login-form">
      {message && (
        <div className="form-group">
          <div className="alert alert-danger" role="alert">
            {message}
          </div>
        </div>
      )}
      {loading && !message && (
          <div className="form-group">
              <div className="alert alert-info" role="alert">
                  Authenticating securely...
              </div>
          </div>
      )}
    </div>
  );
};

export default InventoryServiceLogin;
